import getConfig from 'next/config'

import { getUser as getUserLib } from '@nx/api'

const { publicRuntimeConfig } = getConfig()

export const getUser = (cookies: Parameters<typeof getUserLib>[1]) =>
  getUserLib(publicRuntimeConfig.WEB_API_URL, cookies)
